// extracted by mini-css-extract-plugin
export default {"card":"Tech_card__fgYri","tech":"Tech_tech__+Upww","icon":"Tech_icon__bfpO1"};